<template>
  <v-simple-table dense>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">
            App. No.
          </th>
          <th class="text-left">
            Member Name
          </th>
          <th class="text-left">
            Entity Name
          </th>
          <th class="text-left">
            Trading Name
          </th>
          <th class="text-left">
            Business Name
          </th>
          <th class="text-left">
            Status
          </th>
          <th class="text-left">
            MSA Member No.
          </th>
          <th class="text-end">
            Actions
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="item of items"
          :key="item.applicationNumber"
        >
          <td>{{ item.applicationNumber }}</td>
          <td>{{ item.memberName }}</td>
          <td>{{ item.entityName }}</td>
          <td>{{ item.tradingName }}</td>
          <td>{{ item.businessName || item.entityName }}</td>
          <td>{{ status(item.status) }}</td>
          <td>{{ item.memberNumber }}</td>
          <td class="text-end">
            <v-btn
              v-if="item.status !== RegistrationStatus.COMPLETED"
              color="primary"
              small
              @click="onContinueRegistration(item.applicationNumber)"
            >
              Continue Registration
            </v-btn>
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
import { get } from 'lodash'
import { RegistrationStatus } from '@mymsa/common'

export default {
  name: 'RegistrationList',

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    RegistrationStatus
  }),

  methods: {
    get,
    onContinueRegistration (applicationNumber) {
      this.$emit('continue', applicationNumber)
    },
    status (status) {
      switch (status) {
        case RegistrationStatus.INITIAL:
          return 'Started'
        default:
          return status
      }
    }
  }
}
</script>
